var site = site || {};

(function ($) {
  site.direction = site.direction || {};

  Drupal.behaviors.discoverFoundation = {
    attach: function (context) {
      var discoverContainers = $('.js-discover-foundation-container', context);

      discoverContainers.each(function () {
        var discoverContainer = $(this);
        var carousels = $('.rows', discoverContainer);
        var singleProduct = $('.js-discover-foundation-block-one', discoverContainer);
        var multipleProduct = $('.js-discover-foundation-block-two', discoverContainer);
        var discoverItem = $('.js-discover-foundation-block-item', discoverContainer);
        var foundationBlock = $('.js-discover-foundation-block', discoverContainer);
        var foundationHeader = $('.js-discover-foundation-header', foundationBlock);
        var freeShipping = $('.js-free-shipping', foundationBlock);
        var carouselWidth = 767;
        var singleProductType = true;

        // Set Product Type (Single or Multi)
        if (singleProduct.length > 0) {
          discoverContainer.addClass('discover-foundation-container-one');
        } else if (multipleProduct.length > 0) {
          discoverContainer.addClass('discover-foundation-container-two');
          singleProductType = false;
        }

        // Append Free shipping Title
        if (freeShipping.first().length > 0) {
          freeShipping.first().prependTo(discoverContainer);
          $('.js-free-shipping', foundationBlock).remove();
        }

        // Append Foundation Header
        if (foundationHeader.first().length > 0) {
          foundationHeader.first().prependTo(discoverContainer);
          $('.js-discover-foundation-header', foundationBlock).remove();
        }

        // Carousel Setting
        var settings = {
          rtl: site.direction.isRTL,
          arrows: false,
          responsive: [
            {
              breakpoint: carouselWidth,
              settings: {
                arrows: true,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        };

        // Set Equal Height to Block item
        if (!singleProductType) {
          discoverItem.matchHeight();
        }

        // Carousel initialize
        var carouselsResize = function (e) {
          if (!singleProductType) {
            discoverItem.matchHeight();
          }
          if ($(window).width() < carouselWidth) {
            if (!carousels.hasClass('slick-initialized')) {
              carousels.slick(settings);
            }
          } else {
            if (carousels.hasClass('slick-initialized')) {
              carousels.unslick();
            }
          }
        };

        // Carousel Resize
        $(window).on('load', carouselsResize());
        $(window).on(
          'resize',
          _.debounce(function () {
            carouselsResize();
          }, 250)
        );
      });
    }
  };
})(jQuery);
